const MEDIA_ITEMS = [
  {
    title: '悬疑漫入门指南：从零开始的推理之旅',
    duration: '12:30',
    type: '入门',
    desc: '为你精选10部必看悬疑漫画，从入门到入坑，一步到位。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20detective%20style%20scene%20with%20magnifying%20glass%20on%20wooden%20desk%2C%20warm%20desk%20lamp%20lighting%2C%20mysterious%20atmosphere%2C%20vintage%20study%20room%20with%20books%2C%20soft%20shadows%2C%20noir%20aesthetic%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20rich%20brown%20and%20amber%20tones&width=800&height=480&seq=manga-media-01&orientation=landscape',
  },
  {
    title: '甜到牙疼！本季度恋爱漫画TOP10',
    duration: '08:45',
    type: '盘点',
    desc: '糖分警告！精选本季度最值得追的10部高甜恋爱漫，少女心炸裂。',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20cafe%20scene%20with%20two%20coffee%20cups%2C%20warm%20sunlight%20through%20window%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20cozy%20atmosphere%2C%20delicate%20flowers%20on%20table%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20gentle%20bokeh&width=800&height=480&seq=manga-media-02&orientation=landscape',
  },
  {
    title: '国漫崛起进行时：不容错过的原创佳作',
    duration: '15:20',
    type: '专题',
    desc: '深度解析国漫发展现状，推荐多部画风与剧情俱佳的原创国漫。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ink%20wash%20painting%20style%2C%20misty%20bamboo%20forest%20with%20soft%20morning%20light%2C%20traditional%20and%20modern%20aesthetic%20fusion%2C%20calm%20and%20peaceful%20atmosphere%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20jade%20green%20and%20cream%20tones&width=800&height=480&seq=manga-media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            漫画视听
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            精选漫画专题内容，带你深入了解漫画世界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 谜妹漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}